import Phaser from 'phaser';

var isFontSwis721BTBoldLoaded = false;
var isFontZillaSlabItalicLoaded = false;

function loadFont(name, url) {
    var newFont = new FontFace(name, `url(${url})`);
    newFont.load().then(function (loaded) {
        document.fonts.add(loaded);
    }).catch(function (error) {
        return error;
    });
}



class FlashcardScene extends Phaser.Scene {

    constructor(param) {
        super({key: 'FlashcardScene', config: param.config});
        this.config = param.config;
        this.flashcardImage = null;
        this.rectangleCard = null;
        this.soundImage = null;
        this.dittoImage1 = null;
        this.dittoImage2 = null;

        this.audio = null;

        this.alpha = 0;

        this.wordText = null;
        this.sentenceText = null;

        this.flashcardDM = null;
        this.setResizeEnabled = param.setResizeEnabled;
        this.contentContainer = null;
        this.removeFlashcard = this.removeFlashcard.bind(this);
        this.lastZoomBehavior = 'zoomFitWidth';
        
    }

    preload() {
        console.log('FlashcardScene preload');

        this.load.image('soundimg', './iteam/flashcard/sound.png');
        this.load.image('dittoimg', './iteam/flashcard/ditto.png');

        if (!isFontSwis721BTBoldLoaded) {
            loadFont('Swiss_721_Bold_BT', './iteam/fonts/swiss_721_bold_bt.ttf');
            isFontSwis721BTBoldLoaded = true;
        }

        if (!isFontZillaSlabItalicLoaded) {
            loadFont('Zillas_Lab_Italic', './iteam/fonts/zillaslab-italic.ttf');
            isFontZillaSlabItalicLoaded = true;
        }

        this.contentContainer = this.add.container(0, 0); // I don't now why it is loaded here

        
        this.load.off('filecomplete', this.fileLoadComplete, this);
        this.load.on('filecomplete', this.fileLoadComplete, this);

    }

    create() {
        this.input.on('pointerdown', () => {
            
            if (this.flashcardDM.audios.length > 0 && this.audio !== null) {
                this.audio.play();
            }

            this.alpha = 1;


            if (this.wordText !== null) {
                this.wordText.alpha = this.alpha;
            }
            if (this.sentenceText !== null) {
                this.sentenceText.alpha = this.alpha;
            }
        });
        this.cameras.main.setBackgroundColor('#FFFFFF');

    }


    drawRectangle() {


        let canvasWidth = this.config.width; // this.cameras.main.width;
        let canvasHeight = this.config.height; // this.cameras.main.height;
        
        let graphics = new Phaser.GameObjects.Graphics(this);

        graphics.fillStyle(0xe6e6e5, 1);
    
        let width = canvasWidth * 0.90;
        let height = canvasHeight * 0.90;

        graphics.fillRoundedRect(0, 0, width - 4, height - 4, 40);
    

        if (this.rectangleCard !== null) {
            this.rectangleCard.destroy();
        }


        if (this.textures.exists('flashcardBackgroundCard')) { // delete for reusing
            this.textures.remove('flashcardBackgroundCard');
        }
        graphics.generateTexture('flashcardBackgroundCard', width, height);
    
        this.rectangleCard = this.add.sprite(canvasWidth/2, canvasHeight/2, 'flashcardBackgroundCard').setOrigin(0.5);
        this.contentContainer.add(this.rectangleCard);

    }

    drawImage() {
        let canvasWidth = this.config.width; // this.cameras.main.width;
        let canvasHeight = this.config.height; // this.cameras.main.height;

        let height = canvasHeight * 0.90;

        if (this.flashcardImage !== null) {
            this.flashcardImage.destroy();
            this.flashcardImage = null;
        }


        this.flashcardImage = this.add.sprite(canvasWidth/2, canvasHeight/2, 'flashcard').setOrigin(0.5);
        this.flashcardImage.scale = (height / this.flashcardImage.height) * 0.6;
        this.flashcardImage.setOrigin(0.5);

        this.contentContainer.add(this.flashcardImage);

    }

    drawSoundImage() {
        let canvasHeight = this.config.height;

        let soundX = this.rectangleCard.width / 5;


        if (this.soundImage !== null) {
            this.soundImage.destroy();
            this.soundImage = null;
        }

        this.soundImage = this.add.sprite(soundX, canvasHeight / 2, 'soundimg').setOrigin(0.5);
        this.soundImage.scale = canvasHeight * 0.00015;
        this.soundImage.setOrigin(0.5);

        this.contentContainer.add(this.soundImage);
    }

    drawWordText() {
        let canvasWidth = this.config.width; // this.cameras.main.width;
        let canvasHeight = this.config.height; // this.cameras.main.height;

        let height = canvasHeight * 0.90;

        if (this.wordText !== null) {
            this.wordText.destroy();
            this.wordText = null;
        }

        this.wordText = this.add.text(canvasWidth/2, canvasHeight * 0.12, 
                                        this.flashcardDM.text,
                                        { fontSize: `${Math.round(0.09 * height)}px`,
                                          fontFamily: 'Swiss_721_Bold_BT',
                                          fill: "#4d4e4e" });
        this.wordText.setOrigin(0.5);
        this.wordText.alpha = this.alpha;
        this.contentContainer.add(this.wordText);

    }

    drawSentenceText() {
        let canvasWidth = this.config.width; // this.cameras.main.width;
        let canvasHeight = this.config.height; // this.cameras.main.height;

        let height = canvasHeight * 0.90;
        let width = canvasWidth * 0.90;

        if (this.sentenceText !== null) {
            this.sentenceText.destroy();
            this.sentenceText = null;
        }

        let sentences = this.flashcardDM.sentence.split('\n');
        let sentence = sentences[0];
        sentence = sentence.replace(/<i>/ig, '');
        sentence = sentence.replace(/<\/i>/ig, '');

        let flashcardImageHeight = 400;
        if (this.flashcardImage) {
            flashcardImageHeight = this.flashcardImage.height;
        }

        this.sentenceText = this.add.text(canvasWidth/2, canvasHeight * 0.86, 
                                        sentence,
                                        { fontSize: `${Math.round(24*(height/flashcardImageHeight))}px`,
                                          fontFamily: 'Zillas_Lab_Italic',
                                          wordWrap: { width: width * 0.7, useAdvancedWrap: true },
                                          fill: "#4d4e4e" });
        this.sentenceText.setOrigin(0.5);
        this.sentenceText.alpha = this.alpha;


        this.contentContainer.add(this.sentenceText);

    }

    loadFlashcardDM(flashcardDM) {

        // first clear old stuff.
        this.removeFlashcard();

        if (this.textures.exists('flashcard')) {
            this.textures.remove('flashcard');
        }

        this.alpha = 0;

        // trigger load new stuff
        this.flashcardDM = flashcardDM;

        this.addFlashcardTexts(); // texts are ready, add them immediately

        this.load.image('flashcard', `${this.flashcardDM.basePath}/${this.flashcardDM.pageUrl}`);
        this.load.start();
    }


    removeFlashcard() {
        if (this.flashcardImage !== null) {  // then remove page itself
            this.flashcardImage.off('pointerdown');
            this.flashcardImage.destroy();
            this.flashcardImage = null;
        }

        if (this.rectangleCard !== null) {
            this.rectangleCard.destroy();
            this.rectangleCard = null;
        }

        if (this.wordText !== null) {
            this.wordText.destroy();
            this.wordText = null;
        }

        if (this.sentenceText !== null) {
            this.sentenceText.destroy();
            this.sentenceText = null;
        }

        if (this.soundImage !== null) {
            this.soundImage.destroy();
            this.soundImage = null;
        }

        if (this.dittoImage1 !== null) {
            this.dittoImage1.destroy();
            this.dittoImage1 = null;
        }

        if (this.dittoImage2 !== null) {
            this.dittoImage2.destroy();
            this.dittoImage2 = null;
        }

        if (this.audio !== null) {
            this.audio = null;
        }
    }


    addFlashcardTexts() {

        if (this.contentContainer === null) {
            return;
        }

        this.drawRectangle();
        this.drawWordText();
        this.drawSentenceText();

    }

    addFlashcardImage() {
        this.drawImage();
    }
    
    addFlashcardAudio() {

        if (this.flashcardDM.audios.length > 0 && this.flashcardDM.audios[0].src && this.flashcardDM.audios[0].src.length > 0) {
            let url = `${this.flashcardDM.audios[0].src}`;
            if (this.audio) {
                this.audio = null;
            }
            this.audio = new Audio(url);
        } else {
            if (this.audio) {
                this.audio = null;
            }
        }

        if (this.flashcardDM.audios.length > 0 && this.flashcardDM.audios[0].src && this.flashcardDM.audios[0].src.length > 0) {
            this.drawSoundImage();
        }

    }
    


    zoomRecalculate() {
        this.addFlashcardTexts();
        this.addFlashcardImage();
        this.addFlashcardAudio();
    }


    /*
     * fileLoadComplete - It is callback of loader set up at preload phase.
     *                    It is responsible of adding newly loaded page to the Scene aka Container. 
     */
    fileLoadComplete(key, type, data) {
        if (type === 'image' && key === 'flashcard') {
            console.log('flashcard image fileLoadComplete');
            this.addFlashcardImage();
            this.addFlashcardAudio();
        }
    }

}

export default FlashcardScene;